
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/ia/auditoria-preventiva",
      function () {
        return require("private-next-pages/pt-br/ia/auditoria-preventiva/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/ia/auditoria-preventiva"])
      });
    }
  